import { eventKey as UPLT_EVENT_KEY } from "@faire/web-api--source/events/infra/timing/userPerceivedLoadTiming";
import { TraceEventTracker } from "../pete/TraceEventMarkerTracker";
export function generateTracingMetadata(param) {
    var name = param.name, loadType = param.loadType, status = param.status, result = param.result, userToken = param.userToken, isDesktopAndAbove = param.isDesktopAndAbove, isMobile = param.isMobile;
    var _result_lastImageLoadTime, _result_mainThreadQuietTime, _result_pageMountTime, _result_pageReadyTime;
    return {
        loadType: loadType,
        name: name,
        status: status,
        endTime: result.endTime,
        lastImageLoadTime: (_result_lastImageLoadTime = result.lastImageLoadTime) !== null && _result_lastImageLoadTime !== void 0 ? _result_lastImageLoadTime : undefined,
        mainThreadQuietTime: (_result_mainThreadQuietTime = result.mainThreadQuietTime) !== null && _result_mainThreadQuietTime !== void 0 ? _result_mainThreadQuietTime : undefined,
        pageMountTime: (_result_pageMountTime = result.pageMountTime) !== null && _result_pageMountTime !== void 0 ? _result_pageMountTime : undefined,
        pageReadyTime: (_result_pageReadyTime = result.pageReadyTime) !== null && _result_pageReadyTime !== void 0 ? _result_pageReadyTime : undefined,
        userToken: userToken,
        isDesktopAndAbove: isDesktopAndAbove,
        isMobile: isMobile,
        sourceEventHash: TraceEventTracker.get().getTraceHash(UPLT_EVENT_KEY).sourceEventHash
    };
}
